module.exports = __webpack_public_path__ + "img/gi.c0e73633.svg";